export class RecipeForPrint {
    CalculationWeight: number;
    Id_Owner: number;
    Id_Recipe: number;
    Id_Stage: number;
    NWeek: number;
    RecipeName: string;
    RecipeChanged: number;
    GarbageWeight: number;
    CurrentMenuWeight: number;
    portion: number;
    IsPrint: boolean;
    CalorificValue: number;
    Proteins: number;
    Fats: number;
    Carbohydrates: number;
    PlanId: number;
    ImagePath: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-for-print.ts